import one from "../assets/garden/1.png";
import two from "../assets/garden/2.png";
import three from "../assets/garden/3.png";
import four from "../assets/garden/4.png";
import five from "../assets/garden/5.png";
import six from "../assets/garden/6.png";
import seven from "../assets/garden/7.png";
import eight from "../assets/garden/8.png";
import nine from "../assets/garden/9.png";
import ten from "../assets/garden/10.png";
import eleven from "../assets/garden/11.png";
import twelve from "../assets/garden/12.png";
export default [
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven,
    twelve,
];
